<template>
  <v-container fluid>
    <div class="d-flex flex-column flex-md-row justify-space-between">
      <h1>{{ $t('TRANSPORTER_PAGE.TITLE.HEADER') }}</h1>
    </div>

    <div class="d-flex flex-column flex-md-row justify-space-between">
      <v-tabs
        v-model="tab"
        class="mt-8 mt-md-0"
        color="#559a1b"
      >
        <v-tab
          v-if="checkPermission(['DISTRIBUTOR_TRANSPORTER_READ_PERMISSION'])"
          value="expressist"
        >
          {{ $t('TRANSPORTER_PAGE.TITLE.EXPRESSIST') }}
        </v-tab>
      </v-tabs>
    </div>

    <v-window v-model="tab">
      <v-window-item value="expressist">
        <ExpressistConnexionListComponent
          v-if="this.selectedStore"
          :storeId="this.selectedStore?.technical_id" />
      </v-window-item>
    </v-window>

  </v-container>
  <SelectStoreModal ref="selectStoreModal"/>
</template>

<script>
import { checkPermission } from '@/components/utils/globalFunction';
import SelectStoreModal from '@/components/modal/repair-file/SelectStoreModal.vue';
import ExpressistConnexionListComponent
  from '@/views/restricted/dashboard/transporter/expressist/ExpressistConnexionListComponent.vue'

export default {
  name: 'TransportersPage',
  components: { ExpressistConnexionListComponent, SelectStoreModal },
  data() {
    return {
      tab: 'expressist',
      prevRoute: null,

      selectedStore: null,
      expressistConnexionLink: null
    }
  },
  async mounted() {
    const storeList = this.$store.getters['auth/getStoreListCollaborator']
    if (storeList.length > 1) {
      const response = await this.$refs.selectStoreModal.show({
        arrayList: storeList,
        title: this.$t('EXPRESSIST_TRANSPORTER.DETAIL_PAGE.STORE_MODAL.TITLE'),
        message: this.$t('EXPRESSIST_TRANSPORTER.DETAIL_PAGE.STORE_MODAL.MESSAGE'),
        placeHolder: this.$t('EXPRESSIST_TRANSPORTER.DETAIL_PAGE.STORE_MODAL.PLACEHOLDER'),
        validateButton: this.$t('COMMON.BUTTON.CONTINUE')
      })
      if (response.confirmed) {
        this.selectedStore = response.selection
        this.$store.commit('auth/setRepairFileStoreSelected', this.selectedStore)
      }
    } else {
      this.selectedStore = storeList[0]
      this.$store.commit('auth/setRepairFileStoreSelected', storeList[0])
    }
  },
  methods: {
    checkPermission,
  }
}
</script>

<style scoped>
.v-container {
  padding: 32px;
}

:deep(.v-tab) {
  border-radius: unset;
}

:deep(.v-tab--selected .v-btn__content) {
  font-weight: bold;
}
</style>
